<template>
  <ValidationObserver :ref="formRefName">
    <v-form class="mt-1">
      <v-row>
        <v-col cols="12" md="2">
          <ValidationProvider name="Unit Id"
                              rules="required"
                              v-slot="{ errors }">
            <v-text-field v-model="unitId"
                          :error-messages="errors"
                          label="Unit Id" />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="3">
          <ValidationProvider name="Description"
                              rules="required"
                              v-slot="{ errors }">
            <v-text-field v-model="description"
                          :error-messages="errors"
                          label="Description" />
          </ValidationProvider>
        </v-col>
        <v-col col="12" md="1">
          <ValidationProvider name="Length"
                              :rules="{required: true, min_value: 0.1}"
                              v-slot="{ errors }">
            <v-text-field v-model="length"
                          type="number"
                          :error-messages="errors"
                          label="Length" />
          </ValidationProvider>
        </v-col>
        <v-col col="12" md="1">
          <ValidationProvider name="Width"
                              :rules="{required: true, min_value: 0.1}"
                              v-slot="{ errors }">
            <v-text-field v-model="width"
                          type="number"
                          :error-messages="errors"
                          label="Width" />
          </ValidationProvider>
        </v-col>
        <v-col col="12" md="2">
          <ValidationProvider name="Quantity"
                              :rules="{
                              required: true,
                              min_value: 1
                              }"
                              v-slot="{ errors }">
            <v-text-field v-model="quantity"
                          type="number"
                          :error-messages="errors"
                          label="Quantity" />
          </ValidationProvider>
        </v-col>
        <v-col cols="12" md="2">
          <v-switch v-model="stackLevel"
                    true-value="0"
                    false-value="1"
                    label="Stacked">
          </v-switch>
        </v-col>
        <v-col cols="12" md="1">
          <v-icon @click="removeFormFromDialog">mdi-close-circle</v-icon>
        </v-col>
      </v-row>
    </v-form>
  </ValidationObserver>
</template>

<script>
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import { min_value } from 'vee-validate/dist/rules';

  extend('min_value', {
    ...min_value,
    message: `Must be at least {min}`
  });

  export default {
    name: 'RecordExtraLiftForm',
    components: {
      ValidationProvider,
      ValidationObserver,
    },
    props: {
      removeFormFromDialog: Function,
      formRefName: String,
    },
    data() {
      return {
        description: '',
        unitId: '',
        length: null,
        width: null,
        quantity: null,
        stackLevel: 1,
      }
    },
  };
</script>
